// extracted by mini-css-extract-plugin
export default {"header":"GameHeader_header__aq6r4","game-title":"GameHeader_game-title__SpieH"};